"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationCare = function IllustrationCare() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "65",
    height: "65",
    fill: "none",
    viewBox: "0 0 65 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M7.737 52h50"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "22.409",
    cy: "33.789",
    r: "4.336",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "42.065",
    cy: "33.789",
    r: "4.336",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M32.526 41.594c-2.874 0-5.203 2.377-5.203 5.31V52h10.406v-5.097c0-2.932-2.33-5.31-5.203-5.31z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M32.526 41.594c-2.874 0-5.203 2.377-5.203 5.31V52h10.406v-5.097c0-2.932-2.33-5.31-5.203-5.31z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    fillRule: "evenodd",
    d: "M15.182 45.204c0-3.91 3.106-7.079 6.938-7.079 3.155 0 5.819 2.15 6.66 5.093a5.349 5.349 0 00-1.457 3.685V52h-12.14v-6.796z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6F558A",
    d: "M28.78 43.218l.545.515.294-.31-.118-.411-.72.206zM27.323 52v.75h.75V52h-.75zm-12.14 0h-.75v.75h.75V52zm6.937-14.625c-4.26 0-7.688 3.52-7.688 7.83h1.5c0-3.51 2.785-6.33 6.188-6.33v-1.5zm7.381 5.637c-.928-3.248-3.873-5.637-7.381-5.637v1.5c2.803 0 5.185 1.91 5.94 4.549l1.441-.412zm-1.266-.31a6.099 6.099 0 00-1.662 4.201h1.5c0-1.234.478-2.35 1.252-3.17l-1.09-1.03zm-1.662 4.201V52h1.5v-5.097h-1.5zm-11.39 5.847h12.14v-1.5h-12.14v1.5zm-.75-7.546V52h1.5v-6.796h-1.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    fillRule: "evenodd",
    d: "M35.827 42.8c.965-2.727 3.523-4.675 6.527-4.675 3.831 0 6.938 3.17 6.938 7.08V52H37.728v-5.097a5.34 5.34 0 00-1.902-4.104z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6F558A",
    d: "M35.827 42.8l-.707-.251-.173.49.398.335.482-.575zM49.292 52v.75h.75V52h-.75zm-11.563 0h-.75v.75h.75V52zm4.625-14.625c-3.34 0-6.17 2.166-7.234 5.174l1.414.5c.865-2.443 3.151-4.174 5.82-4.174v-1.5zm7.688 7.83c0-4.31-3.428-7.83-7.688-7.83v1.5c3.403 0 6.188 2.82 6.188 6.33h1.5zm0 6.795v-6.796h-1.5V52h1.5zm-12.313.75h11.563v-1.5H37.728v1.5zm.75-.75v-5.097h-1.5V52h1.5zm0-5.097a6.091 6.091 0 00-2.17-4.679l-.964 1.15a4.59 4.59 0 011.634 3.53h1.5z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "32.526",
    cy: "38.125",
    r: "3.469",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.5 30l6.5-6.5c1.5-1.334 3.8-4.7 1-7.5-2.4-2.4-6-1-7.5 1.5C31 15 27.4 13.6 25 16c-3 3 0 6.5 1 7.5l6.5 6.5z"
  }));
};

var _default = IllustrationCare;
exports.default = _default;